@if (hasRepository()) {
  <!-- Vor der Sektion und nicht in ihr: die Sektion ist selbst eine Live-Region, und
       darin sagte ein Vorleser den Hinweis doppelt an. -->
  @if (connectionLost()) {
    <app-live-reconnect-hint class="live-pipeline-reconnect" messageKey="liveDashboard.livePipeline.reconnecting" />
  }
  <section
    class="live-pipeline"
    data-testid="live-pipeline-section"
    aria-live="polite"
    [attr.aria-labelledby]="headingId"
  >
    <to-section-title
      [headingId]="headingId"
      [title]="'liveDashboard.livePipeline.title' | translate"
      [subtitle]="'liveDashboard.livePipeline.subtitle' | translate"
    >
      @if (allRunsLink(); as link) {
        <a right class="live-pipeline__all-runs" data-testid="live-pipe-all-runs" [routerLink]="link">
          {{ 'liveDashboard.livePipeline.allRuns' | translate }}
          <mat-icon aria-hidden="true">chevron_right</mat-icon>
        </a>
      }
    </to-section-title>

    @if (pipelines().length > 0) {
      <div class="live-pipeline__cards">
        @for (pipeline of pipelines(); track key(pipeline)) {
          <app-live-pipe-card [pipeline]="pipeline" />
        }
      </div>
    } @else {
      <p class="live-pipeline__empty" data-testid="live-pipe-empty">
        {{ 'liveDashboard.livePipeline.empty' | translate }}
      </p>
    }
  </section>
}
